import React, {Component} from 'react'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {changeMiddysStatus} from '../actions/ClientActions';
import Modal from './Modal';

@connect(
    state => ({
        client: state.activeClient.client,
        isSaving: state.modal.isSaving
    }),
    dispatch => bindActionCreators({changeMiddysStatus}, dispatch)
)
export default class MiddysStatusModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMiddy: props.client.isMiddy
        };
    }
    handleSubmit() {
        this.props.changeMiddysStatus(this.props.client.id, this.state);
    }
    render() {
        var actionButton = this.props.isSaving ?
            (<button className="btn btn-success disabled">Updating...</button>) :
            (<button className="btn btn-success" onClick={this.handleSubmit.bind(this)}>Update</button>);

        return (
            <Modal actionButton={actionButton} className="modal-primary" title={"Change Middys Status"}>
                <p>Is this client a customer of Middendorps?</p>
                <input type="checkbox" checked={this.state.isMiddy} onChange={e => this.setState({isMiddy: !this.state.isMiddy})} />
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/MiddysStatusModal.js